__turbopack_context__.v({
  "tools": "page-tools-module__WDXnra__tools",
});
